module.exports = function(vars) {
var __t, __p = '';
__p += '<li class="toolIconInfo"><span class="tooltipLeft ico action-toggle-broadcast-info"\n  title="Broadcast Information" data-title="Broadcast Information" aria-label="Access Broadcast Information"><i class="fa fa-info"></i></span></li>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/infoToolBoxIcon.ejs